import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight, FaCheck, FaMoneyBill } from 'react-icons/fa';
import axios from 'axios';
import useAuth from '../dashboard/useAuth';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import { Modal, Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SouscrirePage = () => {
    useAuth();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    const [formation, setFormation] = useState([]);
    const [produits, setProduits] = useState([]);
    const [selectedFormations, setSelectedFormations] = useState([]);
    const [selectedProduits, setSelectedProduits] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [activeTab, setActiveTab] = useState('formations');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [codePromo, setCodePromo] = useState('');
    const [codePartenaire, setCodePartenaire] = useState('');
    const carouselRef = useRef(null);
    const [translateX, setTranslateX] = useState(0);
    const itemWidth = 250;

    const itemsPerRow = 4;
    const [visibleItems, setVisibleItems] = useState(itemsPerRow);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [formationsRes, produitsRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_HOTE}/liste-formation/`),
                    axios.get(`${process.env.REACT_APP_HOTE}/liste-produit/`)
                ]);

                const formationActive = formationsRes.data.filter(formation => formation.statut === "actif");
                setFormation(formationActive);
                setProduits(produitsRes.data);
            } catch (error) {
                console.error('Erreur:', error);
                setAlert({ message: "Erreur lors du chargement des données", type: 'danger' });
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    // MODIFICATION : Récupérer la référence au lieu de l'ID
    const handleFormationSelection = (formation) => {
        const formationReference = formation.reference;
        setSelectedFormations([formationReference]);
        setSelectedProduits([]);
    };
    
    const handleProduitSelection = (produitId) => {
        setSelectedProduits([produitId]);
        setSelectedFormations([]);
    };

    const handleShowConfirmation = () => {
        if (selectedFormations.length === 0 && selectedProduits.length === 0) {
            setAlert({ message: "Veuillez sélectionner au moins une formation ou un produit", type: 'danger' });
            return;
        }
        setShowConfirmationModal(true);
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOTE}/Souscrire/${user_id}/`, {
                formations: selectedFormations, // Maintenant ce sont des références
                produits: selectedProduits,
                code_promo: codePromo,
                code_partenaire: codePartenaire
            });

            setAlert({ message: response.data.message, type: 'success' });
            setTimeout(() => navigate('/Souscription-utilisateur'), 1000);
        } catch (error) {
            console.error('Erreur:', error);
            setAlert({
                message: error.response?.data?.error || "Erreur lors de la souscription",
                type: 'danger'
            });
        } finally {
            setIsSubmitting(false);
            setShowConfirmationModal(false);
        }
    };

    const handleNextItems = () => {
        const containerWidth = carouselRef.current?.offsetWidth || 0;
        const maxTranslate = -((currentItems.length * itemWidth) - containerWidth);

        setTranslateX(prev => {
            const newTranslate = prev - (containerWidth / 2);
            return Math.max(newTranslate, maxTranslate);
        });
    };

    const handlePrevItems = () => {
        setTranslateX(prev => Math.min(prev + (carouselRef.current?.offsetWidth / 2 || 0), 0));
    };

    const carouselStyle = {
        display: 'flex',
        transition: 'transform 0.5s ease-in-out',
        transform: `translateX(${translateX}px)`,
        willChange: 'transform'
    };

    const currentItems = activeTab === 'formations' ? formation : produits;
    
    // MODIFICATION : Adapter la logique de sélection selon l'onglet actif
    const handleSelection = activeTab === 'formations' 
        ? handleFormationSelection 
        : (item) => handleProduitSelection(item.id); // Pour les produits, on passe l'ID

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre="Nouvelle souscription" />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className='d-flex align-items-center'>
                            <FaMoneyBill size={25} className='mr-2' /> Nouvelle souscription
                        </h2>
                        <small id='hbreadcrumb' className='d-flex justify-content-end'>
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    <Link to="/Liste-souscription">Mes souscriptions</Link>
                                </li>
                                <li className="breadcrumb-item active custom-breadcrumb-item">
                                    <strong>Nouvelle souscription</strong>
                                </li>
                            </ol>
                        </small>
                    </div>
                </div>

                <div className="wrapper wrapper-content animated fadeInRight">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            {alert.message && (
                                <div className={`alert alert-${alert.type} alert-dismissible fade show`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="ibox">
                                <div className="ibox-content">
                                    {isLoading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="mb-4">
                                                <ul className="nav nav-tabs">
                                                    <li className="nav-item">
                                                        <button
                                                            className={`nav-link ${activeTab === 'formations' ? 'active' : ''}`}
                                                            onClick={() => {
                                                                setActiveTab('formations');
                                                                setVisibleItems(itemsPerRow);
                                                            }}
                                                        >
                                                            Formations
                                                        </button>
                                                    </li>
                                                    <li className="nav-item">
                                                        <button
                                                            className={`nav-link ${activeTab === 'produits' ? 'active' : ''}`}
                                                            onClick={() => {
                                                                setActiveTab('produits');
                                                                setVisibleItems(itemsPerRow);
                                                            }}
                                                        >
                                                            Produits
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="mb-5">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <button
                                                        className="btn btn-sm btn-outline-secondary"
                                                        onClick={handlePrevItems}
                                                        disabled={translateX >= 0}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>
                                                    <div className="carousel-container p-2" ref={carouselRef} style={{ overflow: 'hidden', width: '100%' }}>
                                                        <div style={carouselStyle}>
                                                            {currentItems.map(item => (
                                                                <div
                                                                    key={item.id}
                                                                    style={{
                                                                        minWidth: `${itemWidth}px`,
                                                                        padding: '0 10px',
                                                                        flexShrink: 0
                                                                    }}>
                                                                    <div
                                                                        className={`ibox ${(activeTab === 'formations' ? selectedFormations.includes(item.reference) : selectedProduits.includes(item.id)) ? 'border border-success' : ''}`}
                                                                        onClick={() => handleSelection(item)}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            height: '100%',
                                                                            transition: 'all 0.3s ease',
                                                                            transform: (activeTab === 'formations' ? selectedFormations.includes(item.reference) : selectedProduits.includes(item.id)) ? 'scale(1.02)' : 'scale(1)'
                                                                        }}
                                                                    >
                                                                        <div className="ibox-content product-box" style={{ height: '100%' }}>
                                                                            <div className="text-center mb-2" style={{ height: '120px', overflow: 'hidden' }}>
                                                                                <img
                                                                                    src={`${process.env.REACT_APP_HOTE}${item.photo_url}`}
                                                                                    alt={item.nom}
                                                                                    style={{
                                                                                        maxWidth: '100%',
                                                                                        maxHeight: '100%',
                                                                                        objectFit: 'contain',
                                                                                        borderRadius: '5px',
                                                                                    }}
                                                                                    onError={(e) => {
                                                                                        e.target.src = 'https://via.placeholder.com/150';
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div className="product-desc text-center">
                                                                                <strong className="d-block text-truncate">{item.nom}</strong>
                                                                                <small className="text-muted d-block">
                                                                                    {activeTab === 'formations' ? item.periode : 'Produit'}
                                                                                </small>
                                                                                <span className="product-price">{item.prix} FCFA</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <button
                                                        className="btn btn-sm btn-outline-secondary"
                                                        onClick={handleNextItems}
                                                        disabled={Math.abs(translateX) >= ((currentItems.length * itemWidth) - (carouselRef.current?.offsetWidth || 0))}
                                                    >
                                                        <FaArrowRight />
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-end mt-4">
                                                <button
                                                    className="btn btn-secondary mr-2"
                                                    onClick={() => navigate('/Liste-souscription')}
                                                >
                                                    Annuler
                                                </button>
                                                <button
                                                    className="btn btn-success"
                                                    onClick={handleShowConfirmation}
                                                    disabled={selectedFormations.length === 0 && selectedProduits.length === 0}
                                                >
                                                    Souscrire
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de confirmation */}
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
                <Modal.Header>
                    <Modal.Title>Confirmation de souscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Code promo (optionnel)</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Entrez votre code promo"
                                value={codePromo}
                                onChange={(e) => setCodePromo(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Code partenaire (optionnel)</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Entrez votre code partenaire"
                                value={codePartenaire}
                                onChange={(e) => setCodePartenaire(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmationModal(false)}>
                        Annuler
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                En cours...
                            </>
                        ) : 'Confirmer la souscription'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SouscrirePage;